import { getFlags } from '@chargeafter/feature-flag';
import { environment } from '../environment';

export const hashOrigin = async (origin: string): Promise<string> => {
  const encoded = new TextEncoder().encode(origin);
  const hashBuffer = await crypto.subtle.digest('SHA-256', encoded);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
};

export const useLogoutReturnTo = () => {
  return async (): Promise<string> => {
    const { ffSalesAppShouldUseOperateLogoutRedirect } = getFlags();

    if (ffSalesAppShouldUseOperateLogoutRedirect) {
      const hashedOrigin = await hashOrigin(window.location.origin);
      return `${environment.backendBaseUrl}/v2/user-manager/api/auth/redirect?id=${hashedOrigin}&app=SalesApp`;
    }

    return window.location.origin;
  };
};
